export default "__VITE_ASSET__CWHi73TJ__"